module.exports = __webpack_public_path__ + "img/fp-healthguide-logo.dce78873.png";